import privacy from "./privacy";
import terms from "./terms";
import shipping from "./shipping";
import deliveryIssues from "./deliveryIssues";
import returnsRefunds from "./returnsRefunds";
import orderCancellation from "./orderCancellation";
import internationalCustoms from "./internationalCustoms";
import paymentPricingFraud from "./paymentPricingFraud";
import discountsPromotions from "./discountsPromotions";
import clearanceFinalSale from "./clearanceFinalSale";
import productAccuracy from "./productAccuracy";
import productSafety from "./productSafety";
import reviewsContent from "./reviewsContent";
import intellectualProperty from "./intellectualProperty";
import accessibility from "./accessibility";
import packagingSustainability from "./packagingSustainability";
import complaintsDisputes from "./complaintsDisputes";
import policyUpdates from "./policyUpdates";
import cookies from "./cookies";
import faq from "./faq";

const policies = [privacy, terms, shipping, deliveryIssues, returnsRefunds, orderCancellation, internationalCustoms, paymentPricingFraud, discountsPromotions, clearanceFinalSale, productAccuracy, productSafety, reviewsContent, intellectualProperty, accessibility, packagingSustainability, complaintsDisputes, policyUpdates, cookies, faq];
export const policyMap = Object.fromEntries(policies.map((policy) => [policy.slug, policy]));
export default policies;
